
import {computed} from "vue";
import store from "@/store";
import {getVICPrefix} from "@/utils/general";
import HappeningOverviewSingle from "@/components/member/happening/HappeningOverviewSingle.vue";

export default {
  name: "HappeningOverview",
  components: {HappeningOverviewSingle},
  setup() {
    const type = computed(() => store.state.selectedType);
    const list = computed(() => {
      const memberData = store.state.memberData[type.value];
      if (memberData) {
        console.log(memberData);
        return memberData.happenings;
      } else {
        return [];
      }
    });


    const prefix = computed(() => getVICPrefix(type.value));

    return {
      prefix,
      list
    }
  }
}
